import { render, staticRenderFns } from "./MasonryCategoryMenu.vue?vue&type=template&id=7404e890&"
import script from "./MasonryCategoryMenu.vue?vue&type=script&lang=js&"
export * from "./MasonryCategoryMenu.vue?vue&type=script&lang=js&"
import style0 from "./MasonryCategoryMenu.vue?vue&type=style&index=0&id=7404e890&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VSpacer})
